const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const tglID = (s) => {
  if (!s) return "……………";
  const d = new Date(s + "T00:00:00");
  return `${d.getDate()} ${BULAN[d.getMonth()]} ${d.getFullYear()}`;
};
const dmy = (s) => (s ? s.split("-").reverse().join("-") : "");
const v = (x) => (x && String(x).trim() ? x : "……………");
const p2 = (n) => String(n).padStart(2, "0");

export const BIO_LABEL = {
  nama: "Nama Lengkap", nik: "NIK", ktp: "No. KTP", no_kk: "No. Kartu Keluarga", ttl: "Tempat / Tanggal Lahir",
  umur: "Umur", jk: "Jenis Kelamin", agama: "Agama", pekerjaan: "Pekerjaan", status: "Status Perkawinan",
  goldar: "Golongan Darah", wn: "Kewarganegaraan", alamat: "Alamat", rtrw: "RT / RW",
};

export const buildBio = (w) => ({
  nama: w.nama, nik: w.nik, ktp: w.nik, no_kk: w.no_kk, ttl: `${w.tempat_lahir}, ${dmy(w.tanggal_lahir)}`,
  umur: `${w.usia} Tahun`, jk: w.jenis_kelamin, agama: w.agama, pekerjaan: w.pekerjaan, status: w.status_perkawinan,
  goldar: w.golongan_darah, wn: w.kewarganegaraan, alamat: `${w.alamat} RT. ${p2(w.rt)}`, rtrw: `${String(w.rt).padStart(3, "0")} / ${w.rw || "-"}`,
  rt: p2(w.rt), no_hp: w.no_hp, anggota: w.anggota_kk || [],
});

const T = (k, label, type = "text", ph = "") => ({ k, label, type, ph });
const PENUTUP = (nama) => `Demikian surat keterangan ${nama} ini dibuat dengan sebenar-benarnya dan diberikan kepada yang bersangkutan untuk dapat dipergunakan sebagaimana mestinya.`;

export const TEMPLATES = [
  {
    id: "SKBPM", judul: "Surat Keterangan Belum Pernah Menikah", pola: "472.43/{n}/SKBPM/KI/{y}", sign: "pemohon",
    bio: ["nama", "ttl", "jk", "status", "agama", "pekerjaan", "ktp", "alamat"], extras: [],
    body: (b) => [
      "Tersebut namanya di atas adalah benar-benar penduduk Kelurahan Inauga.",
      "Yang bersangkutan selama ini berdomisili di Kelurahan Inauga tidak pernah menunjukkan aktivitas selaku orang yang telah berumah tangga, dan selama pengamatan kami yang bersangkutan adalah benar-benar berstatus bujang/gadis.",
      PENUTUP("Belum Pernah Menikah"),
    ],
  },
  {
    id: "SKTM", judul: "Surat Keterangan Tidak Mampu", pola: "401/{n}/SKTM/KI/{y}", sign: "distrik",
    bio: ["nama", "ttl", "jk", "agama", "pekerjaan", "alamat"], extras: [T("keperluan", "Keperluan (mengurus/melengkapi)", "text", "mis. Beasiswa sekolah, BPJS")],
    body: (b, e) => [
      `Tersebut namanya di atas adalah benar-benar penduduk RT. ${b.rt} Kelurahan Inauga.`,
      `Tersebut namanya di atas adalah benar-benar berstatus ekonomi lemah yang tidak mampu, ingin mengurus / melengkapi ${v(e.keperluan)}.`,
      "Mohon surat keterangan ini digunakan sebagaimana mestinya.",
      "Demikian surat keterangan Tidak Mampu ini dibuat untuk dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKKT", judul: "Surat Keterangan Keterlambatan", pola: "857/{n}/KI/{y}", sign: "lurah",
    bio: ["nama", "umur", "pekerjaan"], extraRows: [["Departemen", "departemen"], ["No. Karyawan", "no_karyawan"]], bioAfter: ["alamat"],
    extras: [T("departemen", "Departemen"), T("no_karyawan", "No. Karyawan"), T("alasan", "Alasan", "text", "Karena urusan keluarga"),
      T("mulai", "Tidak masuk mulai", "date"), T("sampai", "Sampai dengan", "date"), T("kembali", "Kembali bekerja", "date")],
    body: (b, e) => [
      `Yang bersangkutan adalah benar-benar warga resmi Kelurahan Inauga RT. ${b.rt}.`,
      `Yang bersangkutan tidak dapat kembali bekerja sebagaimana biasanya berhubung ${v(e.alasan)}.`,
      `Yang bersangkutan tidak masuk bekerja mulai tanggal ${tglID(e.mulai)} s/d ${tglID(e.sampai)}.`,
      `Yang bersangkutan kembali ke tempat kerja pada tanggal ${tglID(e.kembali)}.`,
      "Demikian surat keterangan ini kami buat dan diberikan kepada yang berkepentingan agar dapat dipergunakan sebagaimana mestinya. Atas perhatian pihak perusahaan kami ucapkan terima kasih.",
    ],
  },
  {
    id: "SKSM", judul: "Surat Keterangan Sudah Menikah", pola: "472/{n}/SKSM/KI/{y}", sign: "pemohon",
    bio: ["nama", "ttl", "jk", "agama", "pekerjaan"], extraRows: [["Nomor Surat Nikah", "no_nikah"]], bioAfter: ["alamat"],
    extras: [T("no_nikah", "Nomor Surat Nikah"), T("sejak", "Berdomisili sejak tahun", "number", "2015")],
    body: (b, e) => [
      `Yang bersangkutan benar-benar berdomisili di Kelurahan Inauga RT. ${b.rt} sejak tahun ${v(e.sejak)} sampai saat ini.`,
      "Yang bersangkutan benar-benar sudah pernah menikah dan diketahui oleh RT setempat.",
      "Demikian Surat Keterangan Sudah Menikah ini dibuat agar dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKJD", judul: "Surat Keterangan Janda / Duda", pola: "882.5/{n}/SKJD/KI/{y}", sign: "pemohon",
    bio: ["nama", "nik", "ttl", "jk", "agama", "pekerjaan", "status", "no_kk", "alamat"],
    extras: [T("pasangan", "Nama suami/istri (alm.)"), T("akta", "Dasar akta / dokumen", "text", "Kutipan Akta Kematian Dukcapil Kab. Mimika"), T("tgl_akta", "Tanggal akta", "date")],
    body: (b, e) => [
      `Yang bersangkutan adalah benar-benar penduduk Kelurahan Inauga yang telah ditinggalkan (${String(b.status).toLowerCase()}) oleh ${b.jk === "Perempuan" ? "suami" : "istri"} yang bernama ${v(e.pasangan)} sesuai dengan ${v(e.akta)} tertanggal ${tglID(e.tgl_akta)}.`,
      PENUTUP("Janda / Duda"),
    ],
  },
  {
    id: "SKSMB", judul: "Surat Keterangan Sedang Membangun", pola: "593.5/{n}/SKSM/KI/{y}", sign: "distrik",
    bio: ["nama", "umur", "pekerjaan", "ktp", "alamat"],
    extras: [T("bangunan", "Sedang membangun", "text", "Rumah tinggal"), T("panjang", "Panjang (m)", "number"), T("lebar", "Lebar (m)", "number"), T("jalan", "Lokasi jalan"), T("rt_lokasi", "RT lokasi", "number")],
    body: (b, e) => [
      `Tersebut namanya di atas adalah benar-benar penduduk Kelurahan Inauga yang berdomisili di ${b.alamat}.`,
      `Tersebut namanya di atas adalah benar-benar sedang membangun ${v(e.bangunan)} dan dalam tahap penyelesaian dengan ukuran ${v(e.panjang)} x ${v(e.lebar)} M = ${e.panjang && e.lebar ? (Number(e.panjang) * Number(e.lebar)).toLocaleString("id-ID") : "……"} M² yang terletak di jalan ${v(e.jalan)} RT. ${v(e.rt_lokasi)} Kelurahan Inauga.`,
      "Demikian surat keterangan ini dibuat dan diberikan kepada yang bersangkutan untuk dipergunakan dalam pengurusan surat IMB/PBG dari instansi/dinas yang berwenang.",
    ],
  },
  {
    id: "SKITU", judul: "Surat Keterangan Ijin Tempat Usaha", pola: "517/{n}/KI/{y}", sign: "lurah",
    intro: "Kepala Kelurahan Inauga dengan ini menerangkan bahwa :",
    bio: ["nama", "ttl", "jk"], extraRows: [["Nama Usaha", "usaha"]], bioAfter: ["alamat"],
    extras: [T("usaha", "Nama usaha"), T("jalan", "Jalan lokasi usaha"), T("rtrw", "RT / RW lokasi usaha")],
    body: (b, e) => [
      "Perusahaan / kios / toko benar-benar berada di wilayah Inauga yang terletak di :",
      { rows: [["Jalan", v(e.jalan)], ["Kelurahan", "Inauga"], ["Distrik", "Wania"], ["Kabupaten", "Mimika"], ["RT / RW", v(e.rtrw)]] },
      "Demikian surat keterangan Tempat Usaha ini diberikan kepada yang bersangkutan agar dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKK", judul: "Surat Keterangan Kematian", pola: "472.12.A/{n}/SKK/KI/{y}", sign: "an_lurah",
    bio: ["nama", "umur", "pekerjaan", "alamat"],
    extras: [T("sejak", "Berdomisili sejak tahun", "number"), T("tgl", "Tanggal meninggal", "date"), T("jam", "Jam", "text", "14.30 WIT"),
      T("sebab", "Sebab kematian"), T("tempat", "Tempat kematian"), T("p_nama", "Nama pelapor"), T("p_umur", "Umur pelapor"),
      T("p_kerja", "Pekerjaan pelapor"), T("p_alamat", "Alamat pelapor")],
    body: (b, e) => [
      `Tersebut namanya di atas adalah benar-benar penduduk Kelurahan Inauga yang sudah berdomisili sejak tahun ${v(e.sejak)}.`,
      "Tersebut namanya di atas telah meninggal dunia pada :",
      { rows: [["Hari / Tanggal", e.tgl ? `${new Date(e.tgl + "T00:00:00").toLocaleDateString("id-ID", { weekday: "long" })}, ${tglID(e.tgl)}` : "……………"], ["Jam", v(e.jam)], ["Sebab Kematian", v(e.sebab)], ["Tempat Kematian", v(e.tempat)]] },
      "Pelapor :",
      { rows: [["Nama", v(e.p_nama)], ["Umur", v(e.p_umur)], ["Pekerjaan", v(e.p_kerja)], ["Alamat", v(e.p_alamat)]] },
      "Demikian surat keterangan kematian ini kami buat dengan sesungguhnya dan diberikan kepada pihak keluarga untuk dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SPB", judul: "Surat Pengantar BPJS", pola: "440/{n}/SPB/KI/{y}", sign: "pemohon",
    bio: ["nama", "ttl", "jk", "agama", "pekerjaan", "ktp", "goldar", "alamat"], extras: [T("sejak", "Berdomisili sejak tahun", "number")],
    body: (b, e) => [
      "Tersebut namanya di atas adalah benar-benar penduduk Kelurahan Inauga.",
      `Yang bersangkutan adalah benar-benar warga RT. ${b.rt} yang berdomisili sejak tahun ${v(e.sejak)}.`,
      "Demikian surat pengantar ini dibuat dengan sebenar-benarnya dan diberikan kepada yang bersangkutan untuk dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKTB", judul: "Surat Keterangan Tidak Berdomisili", pola: "471.32/{n}/SKTB/KI/{y}", sign: "lurah",
    bio: ["nama", "umur", "jk", "pekerjaan"], extraRows: [["Keterangan", "ket"]], bioAfter: ["alamat"], extras: [T("ket", "Keterangan", "text", "Pindah ke luar daerah")],
    body: () => [
      "Tersebut namanya di atas adalah benar-benar warga Timika dan pernah berdomisili di Kelurahan Inauga Distrik Wania, namun saat ini yang bersangkutan sudah tidak lagi berdomisili di Kelurahan Inauga Distrik Wania.",
      "Mohon bantuan pihak yang berkepentingan agar dapat melayani, dan atas bantuan serta kerja samanya disampaikan terima kasih.",
      PENUTUP("Tidak Berdomisili"),
    ],
  },
  {
    id: "SKDPY", judul: "Surat Keterangan Domisili Perusahaan / Yayasan", pola: "511.3/{n}/KI/{y}", sign: "pemohon", pejabat: true,
    bio: [], extras: [T("perusahaan", "Nama perusahaan / yayasan"), T("alamat_usaha", "Alamat usaha"), T("rt_usaha", "RT lokasi", "number"), T("aktivitas", "Aktivitas", "text", "melaksanakan aktivitas pembelajaran")],
    body: (b, e) => [
      "Dengan ini menerangkan bahwa :",
      { rows: [["Nama Perusahaan", v(e.perusahaan)], ["Alamat Usaha", v(e.alamat_usaha)], ["Kelurahan", "Inauga"], ["Distrik", "Wania"], ["Nama Penanggung Jawab", b.nama], ["No. HP", v(b.no_hp)]] },
      `Surat keterangan ini dikeluarkan untuk menerangkan bahwa ${v(e.perusahaan)} yang berdomisili di ${v(e.alamat_usaha)} RT. ${v(e.rt_usaha)} Kelurahan Inauga Distrik Wania Kabupaten Mimika Provinsi Papua Tengah masih AKTIF dalam ${v(e.aktivitas)} sampai sekarang.`,
      "Demikian surat keterangan domisili ini dikeluarkan agar dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKPP", judul: "Surat Keterangan Pindah Penduduk", pola: "471.2/{n}/KI/{y}", sign: "pemohon", anggota: true,
    bio: ["nama", "ttl", "jk", "status", "agama", "ktp", "rtrw", "pekerjaan"], extraRows: [["Tujuan Pindah", "tujuan"]], bioAfter: ["alamat"],
    extraRowsEnd: [["Alamat Tujuan", "alamat_tujuan"], ["Tanggal Berangkat", "berangkat"]],
    extras: [T("tujuan", "Tujuan pindah", "text", "Menetap"), T("alamat_tujuan", "Alamat tujuan"), T("berangkat", "Tanggal berangkat", "date")],
    body: () => ["Yang bersangkutan adalah benar-benar penduduk Kelurahan Inauga yang diberikan surat keterangan pindah penduduk ini agar dapat dipergunakan sebagaimana mestinya."],
  },
  {
    id: "SKBPB", judul: "Surat Keterangan Belum Pernah Bekerja", pola: "474/{n}/KI/{y}", sign: "pemohon",
    bio: ["nama", "ttl", "jk", "agama", "pekerjaan", "ktp"], extraRows: [["Keterangan", "ket"]], bioAfter: ["alamat"],
    extras: [T("ket", "Keterangan", "text", "Mencari pekerjaan"), T("sejak", "Terdaftar sejak tanggal", "date")],
    body: (b, e) => [
      `Tersebut namanya di atas adalah benar-benar penduduk RT. ${b.rt} Kelurahan Inauga terdaftar sejak tanggal ${tglID(e.sejak)}.`,
      "Nama tersebut di atas benar-benar belum pernah bekerja di perusahaan atau instansi manapun.",
      "Mohon bantuan pihak yang berkepentingan agar dapat melayani, dan atas bantuannya disampaikan terima kasih.",
      "Demikian surat keterangan ini diberikan kepada yang bersangkutan untuk dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKBDLK", judul: "Surat Keterangan Berada di Luar Kota", pola: "664/{n}/SKBDLK/KI/{y}", sign: "lurah",
    intro: "Yang bertanda tangan di bawah ini Kepala Kelurahan Inauga dengan ini menerangkan bahwa :",
    bio: ["nama", "nik", "ttl", "agama", "jk", "pekerjaan", "alamat"], extras: [T("ket", "Keterangan", "text", "Sedang menempuh pendidikan di Makassar")],
    body: (b, e) => [
      "Tersebut namanya di atas adalah benar-benar penduduk Kelurahan Inauga.",
      `Yang bersangkutan ${v(e.ket)}, benar-benar tidak berdomisili di Timika atau sedang di luar kota.`,
      "Demikian surat keterangan ini dibuat dan diberikan kepada yang bersangkutan untuk dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKDP", judul: "Surat Keterangan Domisili Perusahaan", pola: "471.3/{n}/KI/{y}", sign: "lurah",
    intro: "Yang bertanda tangan di bawah ini Kepala Kelurahan Inauga Distrik Wania menerangkan bahwa :",
    bio: ["nama", "ttl", "jk", "alamat", "ktp", "pekerjaan"],
    extras: [T("perusahaan", "Nama perusahaan"), T("alamat_usaha", "Alamat usaha"), T("telp", "No. telepon"), T("bidang", "Jenis / bidang usaha")],
    body: (b, e) => [
      "Benar saat ini mempunyai usaha sebagai berikut :",
      { rows: [["Nama Perusahaan", v(e.perusahaan)], ["Alamat Usaha", v(e.alamat_usaha)], ["Kelurahan", "INAUGA"], ["No. Telp", v(e.telp)], ["Jenis / Bidang Usaha", v(e.bidang)]] },
      "Demikian surat keterangan domisili perusahaan ini dibuat dengan sebenar-benarnya agar dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKUD", judul: "Surat Keterangan Usaha dan Domisili", pola: "511.3/{n}/KI/SKUD/{y}", sign: "lurah",
    bio: ["nama", "ttl", "jk", "agama", "pekerjaan"], extraRows: [["Nama Usaha", "usaha"], ["Alamat Usaha", "alamat_usaha"]],
    extras: [T("usaha", "Nama usaha"), T("alamat_usaha", "Alamat usaha"), T("sejak", "Didirikan sejak tahun", "number")],
    body: (b, e) => [
      `Surat keterangan ini dikeluarkan untuk menerangkan bahwa usaha ${v(e.usaha)} yang didirikan sejak tahun ${v(e.sejak)} berdomisili di ${v(e.alamat_usaha)} Kelurahan Inauga Distrik Wania.`,
      "Demikian surat keterangan domisili usaha ini dikeluarkan agar dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKPG", judul: "Surat Keterangan Penguburan", pola: "472.12.B/{n}/KI/{y}", sign: "lurah", pejabat: true,
    bio: [], extras: [T("tgl", "Tanggal meninggal", "date"), T("u_nama", "Diurus oleh (nama)"), T("u_ttl", "Tempat & tanggal lahir pengurus"), T("u_alamat", "Alamat pengurus")],
    body: (b, e) => [
      "Dengan ini menerangkan bahwa :",
      { rows: [["Nama Almarhum / Almarhumah", b.nama], ["Tanggal Meninggal", tglID(e.tgl)], ["Alamat", b.alamat]] },
      "Selama sakit sampai almarhum/almarhumah meninggal diurus oleh :",
      { rows: [["Nama", v(e.u_nama)], ["Tempat dan Tanggal Lahir", v(e.u_ttl)], ["Alamat", v(e.u_alamat)]] },
      "Demikian surat keterangan ini dibuat untuk dapat dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SKIB", judul: "Surat Keterangan Ijin Bepergian", pola: "471.23/{n}/SKIB/KI/{y}", sign: "pemohon",
    intro: "Yang bertanda tangan di bawah ini, Kepala Kelurahan Inauga Distrik Wania Kabupaten Mimika dengan ini menerangkan bahwa :",
    bio: ["nama", "jk", "ttl", "status", "wn", "agama", "pekerjaan", "alamat"], extras: [T("tujuan", "Daerah tujuan"), T("maksud", "Maksud & tujuan")],
    body: (b, e) => [
      `Yang bersangkutan adalah benar-benar warga Kelurahan Inauga yang berdomisili di RT. ${b.rt}, Kabupaten Mimika dan mengajukan surat permohonan ijin bepergian ke daerah ${v(e.tujuan)} dengan maksud dan tujuan untuk ${v(e.maksud)}. Berdasarkan sepengetahuan kami yang bersangkutan berkelakuan baik.`,
      "Demikian surat keterangan ijin bepergian ini dibuat agar dipergunakan sebagaimana mestinya.",
    ],
  },
  {
    id: "SPBB", judul: "Surat Pernyataan Belum Bekerja", pola: "474.2/{n}/PBB/KI/{y}", sign: "pemohon", pernyataan: true,
    intro: "Yang bertanda tangan di bawah ini :",
    bio: ["nama", "ttl", "agama", "jk", "status"], extraRows: [["Keterangan", "ket"]], bioAfter: ["alamat"], extras: [T("ket", "Keterangan", "text", "Mencari pekerjaan")],
    body: () => [
      "Menyatakan bahwa saya belum bekerja dan tidak sedang terikat dengan perusahaan / instansi manapun.",
      "Demikian surat pernyataan ini saya buat dengan sesungguhnya, dan saya bersedia menerima sanksi atau tindakan yang diambil oleh pihak terkait apabila di kemudian hari terbukti pernyataan saya tidak benar.",
    ],
  },
];

export const pejabatRows = (p) => [["Nama", p.nama], ["NIP", p.nip || "-"], ["Jabatan", p.jabatan]];
export const tplById = (id) => TEMPLATES.find((t) => t.id === id);
